export interface DataEntity_Detail_03_Interface {
  id: number,
  main_id: number,

  uncertainty: string,
  reference_Value: string,
  converage: string,
  correction: string,
  reference: string,
  indication: string,
  value: string,

  before:boolean,
}

export function Empty_DataEntity_Detail_03_Interface(): DataEntity_Detail_03_Interface {
  return {
    id: 0,
    main_id: 0,

    uncertainty: '',

    reference_Value: '',

    converage: '',
    correction: '',

    reference: '',
    indication: '',
    value: '',


    before:false
  }
}
